module.exports = __webpack_public_path__ + "Flag-152.56c798cdec00a4f9ceece7d9bbdccaa7.svg";